
class Edge {
    constructor(points, buttonId, nodeId) {
        this.points = points; // Point []
        this.nodeId = nodeId;
        this.buttonId = buttonId;
    }

    addPoint(point) {
        this.points.push(point);
    }

    removePoint(){
        this.points.pop()
    }

    getLastPoint(){
        if(this.points.length === 0)return null;

        return this.points[this.points.length - 1];
    }

    getLastPrevPoint(){
        if(this.points.length < 2)return null;

        return this.points[this.points.length - 2];
    }

    getLastDirection(){
        if(this.points.length < 2)return 'none';

        if(this.getLastPoint().x === this.getLastPrevPoint().x){
            return this.getLastPoint().y > this.getLastPrevPoint().y ? 'bottom' : 'top';
        }

        return this.getLastPoint().x > this.getLastPrevPoint().x ? 'right' : 'left';
    }
}

export default Edge;


// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/graph/containers/GraphView/structures/Edge.js